import { useInfiniteQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { getNextPageParam, getPagesContent } from '@pkg/hooks';

import { callGetNFTOwners } from '@app/client/resources/yat-pages/page-items';
import { PathParams } from '@app/routes/types';

export const useNFTMainOwnerData = (contactProp?: string, itemIdProp?: string, disabled?: boolean) => {
    const { [PathParams.Contract]: contractParam, [PathParams.Id]: itemIdParam } = useParams();
    const itemId = itemIdProp || itemIdParam;
    const contract = contactProp || contractParam;
    const cache = ['ownerData', contract, itemId];
    const queryParams = new URLSearchParams(location.search);
    const emojiID = queryParams.get('emojiID');

    const {
        data: dataRaw,
        isError,
        isLoading,
        isFetching,
    } = useInfiniteQuery(
        cache,
        ({ signal, pageParam }) =>
            callGetNFTOwners({
                query: { limit: 500, page: pageParam || 0 },
                contract: contract || '',
                itemId: itemId || '',
                settings: {
                    signal,
                },
            }),
        {
            retry: false,
            enabled: Boolean(contract && itemId) && !disabled,
            getNextPageParam,
        },
    );

    const data = getPagesContent(dataRaw?.pages);

    const owner = (emojiID && data?.find((owner) => owner.primary_yat === emojiID)) || data?.[0];

    return {
        data,
        isError,
        isFetching,
        isLoading,
        owner,
    };
};
